import React from "react";
import DashboardUserProfile from "./DashboardUserProfile";

const DashboardPageHeader = () => {
  return (
    <header className="study-dashboard__header">
      <DashboardUserProfile />
    </header>
  );
};

export default DashboardPageHeader;
